module.exports = __webpack_public_path__ + "img/test_paperimage.9e798ee5.png";